export default __webpack_public_path__ + "static/media/Logo_C++.2441702d.svg";